"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRemoteData = getRemoteData;
exports.getServerList = getServerList;
exports.linkApi = linkApi;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _http = require("./http");

var _vueJsonView = require("vue-json-view");

var _ = require("..");

var _antDesignVue = require("ant-design-vue");

var cache = {};

function getRemoteData(_x, _x2) {
  return _getRemoteData.apply(this, arguments);
}

function _getRemoteData() {
  _getRemoteData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, params) {
    var cacheFlag,
        data,
        res,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cacheFlag = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;

            if (!cacheFlag) {
              _context.next = 5;
              break;
            }

            data = cache[url + JSON.stringify(params || {})];

            if (!data) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", data);

          case 5:
            _context.prev = 5;
            _context.next = 8;
            return _http.http.get(url, params);

          case 8:
            res = _context.sent;
            cache[url + JSON.stringify(params || {})] = res;
            return _context.abrupt("return", res);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);

            _antDesignVue.message.error('部分数据获取不到');

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 13]]);
  }));
  return _getRemoteData.apply(this, arguments);
}

function getServerList(_x3) {
  return _getServerList.apply(this, arguments);
}

function _getServerList() {
  _getServerList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(formId) {
    var cacheFlag,
        data,
        res,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cacheFlag = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;

            if (!cacheFlag) {
              _context2.next = 5;
              break;
            }

            data = cache[formId];

            if (!data) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", data);

          case 5:
            _context2.next = 7;
            return _.FormApi.getList(formId);

          case 7:
            res = _context2.sent;
            cache[formId] = res;
            return _context2.abrupt("return", res);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getServerList.apply(this, arguments);
}

function linkApi(list, cb) {
  var taskList = [];
  list.forEach(function (component, i) {
    // 使用 _apiLink 属性关联表单
    if (component._apiLink && component._apiLink.url) {
      var config = component._apiLink;
      var task = getRemoteData(config.url, {
        params: config.data ? JSON.parse(config.data) : {}
      }, !component.disableCache);
      taskList.push(task);
      task.then(function (res) {
        cb(_vueJsonView.Utils.setDataByObj(component, (0, _defineProperty2.default)({}, config.linkPath, res.data)), i);
      });
      delete component._apiLink;
    } // 使用 link 属性关联表单


    if (component.link && component.link.formId) {
      var children = component.children || {};
      var link = component.link; // 特殊处理 不是搜索 而是选择 的逻辑

      if (children.type && JSON.stringify(children.type).includes('labelValue')) {
        var _task = getServerList(link.formId, component.disableCache);

        taskList.push(_task);

        _task.then(function (list) {
          var showNames = link.showFields && link.showFields.map(function (field) {
            return field.name;
          }) || [];
          var newList = list.map(function (item) {
            return {
              label: showNames.map(function (name) {
                return item[name];
              }).join(' / ') || 'name',
              value: item._id
            };
          });
          cb(_vueJsonView.Utils.setDataByObj(component, (0, _defineProperty2.default)({}, 'children.options', newList)), i);
        });

        delete component.link;
      } else if (children.tag === 'mh-select') {
        component.children.link = link;
      }
    } // 子表单 和 关联表单 处理


    if (component._type && (component._type.type === 'objectArray' || component._type.type === 'spreadArray') && component._type.path) {
      var _children = _vueJsonView.Utils.getDataByName(component, component._type.path);

      if (_children && _children.length) {
        taskList.push.apply(taskList, (0, _toConsumableArray2.default)(linkApi(_children, function (item, j) {
          return cb(_vueJsonView.Utils.setDataByObj(component, (0, _defineProperty2.default)({}, "".concat(component._type.path, "[").concat(j, "]"), item)), i);
        })));
      }
    }
  });
  return taskList;
}